/* eslint-disable react/no-unknown-property */
import {
  Card,
  CardSkeleton,
  ICON_ALERT_CIRCLE_OUTLINE,
  ICON_BULLSEYE_ARROW,
  Message,
} from '@doveit/bricks';
import React from 'react';
import useIndividualGoal from '../../hooks/use-individual-goal/useIndividualGoal';
import { AgentGoalSimulationView } from '../agent-goal-simulation-view/AgentGoalSimulationView';
import { AgentGoalMetricsView } from '../agent-goal-metrics-view/AgentGoalMetricsView';
import { Agent } from '../../../providers/api/dtos';
import EditAgentGoalAction from '../edit-agent-goal-action/EditAgentGoalAction';

export interface AgentGoalWidgetProps {
  agentId: NonNullable<Agent['id']>,
}

export const LOAD_GOAL_ERROR_MESSAGE = 'Non è stato possibile caricare le informazioni degli obiettivi.';

export const AgentGoalWidget: React.FC<AgentGoalWidgetProps> = ({
  agentId,
}) => {
  const {
    data: existingGoal,
    isLoading: isExistingGoalLoading,
    error: existingGoalError,
    mutate: mutateExistingGoal,
  } = useIndividualGoal(agentId);

  const onGoalAccepted = React.useCallback(() => {
    mutateExistingGoal();
  }, [mutateExistingGoal]);

  if (isExistingGoalLoading) {
    // todo: maybe make custom skeleton
    return <CardSkeleton aria-label="Obiettivi personali in caricamento" />;
  }

  if (existingGoalError && existingGoalError.status !== 404) {
    return (
      <Card>
        <Card.Header
          icon={{ path: ICON_ALERT_CIRCLE_OUTLINE }}
          title="Obiettivi personali"
          color="critical"
        />
        <Card.Content>
          <Message message={LOAD_GOAL_ERROR_MESSAGE} />
        </Card.Content>
      </Card>
    );
  }

  return (
    <Card aria-label="Obiettivi personali">
      <Card.Header
        title="Obiettivi personali"
        icon={{ path: ICON_BULLSEYE_ARROW }}
        primaryActions={existingGoal ? [
          <EditAgentGoalAction
            agentId={agentId}
            label="Modifica"
          />,
        ] : []}
      />
      <Card.Content>
        {existingGoal
          ? <AgentGoalMetricsView goal={existingGoal} />
          : (
            <AgentGoalSimulationView
              agentId={agentId}
              onGoalAccepted={onGoalAccepted}
            />
          )}
      </Card.Content>
    </Card>
  );
};

export default AgentGoalWidget;
